/* LWL — Beden Asistanı (v1, kural tabanlı)
   Boy, kilo, giyim tercihi ve (isteğe bağlı) vücut tipinden vücut ölçülerini tahmin eder; ürünün ölçüleri,
   kalıbı ve kumaş esnekliğiyle karşılaştırıp her bedene puan verir. Veri: window.LWL_OLCU (lwl-urun-olcu.js),
   [data-luo-meta]. Profil cihazda saklanır (lwlBedenProfil). Sepete eklenen satıra gizli _beden_oneri yazılır. */
(function () {
	if (window.__lbaInit) return;
	window.__lbaInit = true;
	var V = 'v2';
	var data = window.LWL_OLCU;
	var metaEl = document.querySelector('[data-luo-meta]');
	if (!data || !data.parcalar || !metaEl) return;
	var meta = {};
	try { meta = JSON.parse(metaEl.textContent); } catch (e) {}
	var PROF_KEY = 'lwlBedenProfil', TOUR_KEY = 'lwlBaTur';
	function ls(k, v) {
		try {
			if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null');
			localStorage.setItem(k, JSON.stringify(v));
		} catch (e) { return null; }
	}
	var TERCIH = [
		{ k: 'oturan', t: 'Vücuduma oturan', d: 'Dar, tam üstüme' },
		{ k: 'normal', t: 'Rahat, normal', d: 'Ne dar ne bol' },
		{ k: 'bol', t: 'Bol, salaş', d: 'Oversize görünüm' }
	];
	var VUCUT = [
		{ k: 'orta', t: 'Standart', d: 'Kilom vücuduma dengeli dağılmış' },
		{ k: 'genis', t: 'Atletik', d: 'Göğüs ve omuzlarım geniş' },
		{ k: 'gobek', t: 'Göbekli', d: 'Karın bölgem belirgin' }
	];
	var female = data.parcalar.some(function (p) { return ['bluz', 'etek', 'elbise'].indexOf(p.tip) >= 0; });

	/* ---------- hesap ---------- */
	function body(p) {
		var H = p.boy, W = p.kilo, c, w, h;
		if (female) {
			c = 92 + 0.8 * (W - 62) - 0.2 * (H - 165);
			w = 74 + 0.9 * (W - 62) - 0.3 * (H - 165);
			h = 100 + 0.75 * (W - 62) - 0.1 * (H - 165);
		} else {
			c = 103 + 0.75 * (W - 80) - 0.25 * (H - 178);
			w = 88 + 0.95 * (W - 80) - 0.35 * (H - 178);
			h = 100 + 0.6 * (W - 80) - 0.1 * (H - 178);
		}
		var adj = { ince: [-3, -4, -2], orta: [0, 0, 0], genis: [4, 1, 1], gobek: [1, 8, 3] }[p.vucut || 'orta'] || [0, 0, 0];
		return { gogus: c + adj[0], bel: w + adj[1], basen: h + adj[2], boy: H };
	}
	function stretch() { return { 'Çok esnek': 4, 'Az esnek': 2 }[meta.esneklik] || 0; }
	function evalSize(p, s) {
		p = { boy: p.boy, kilo: p.kilo, vucut: p.vucut === 'ince' ? 'orta' : p.vucut, tercih: 'normal' };   /* ürünler kendi kalıbında (oversize vb.) önerilir */
		var b = body(p), st = stretch(), score = 0, notes = [], why = [];   /* why: bu bedenin giyilemeyeceği durumlar */
		var T = { oturan: 6, normal: 12, bol: 20 }[p.tercih], MIN = { oturan: 2, normal: 6, bol: 12 }[p.tercih];
		/* v2: oversize kalıpta müşteriler büyük buluyor (iadeler) → hedef bolluk 12→8,5, en az 6→3 cm */
		if (/oversize/i.test(meta.kalip || '')) { T -= 3.5; MIN -= 3; }
		data.parcalar.forEach(function (part) {
			var o = (part.olcu || {})[s] || {};
			if (part.grup === 'ust' || part.tip === 'elbise') {
				if (o.gogus) {
					var circ = 2 * o.gogus, ease = circ - b.gogus;
					var tgt = T - st, mn = MIN - st;
					score += Math.abs(ease - tgt);
					if (ease < mn) score += (mn - ease) * 3;
					if (ease < 2 - st) why.push({ ad: 'Göğüs', body: b.gogus, lim: circ + st - 2, yon: 'dar' });   /* v2: dokuma gömlekte en az 2 cm pay */
					/* düz kesimde göbek: gövde çevresi göğüs çevresini aşmasın */
					var we = circ - b.bel;
					if (we < 4) score += (4 - we) * 2;
					notes.push({ k: 'gogus', ad: 'Göğüs', body: b.gogus, g: circ, ease: ease });
				}
				if (o.boy) {
					var Li = (female ? 0.37 : 0.415) * b.boy + (p.tercih === 'bol' ? 2 : 0);
					if (o.boy < Li - 4) score += (Li - 4 - o.boy) * 1.5;
					if (o.boy > Li + 9) score += (o.boy - Li - 9) * 0.7;
					notes.push({ k: 'boy', ad: 'Boy', ideal: Li, g: o.boy });
				}
				if (o.kol && o.omuz) {
					var arm = o.omuz / 2 + o.kol, Ai = 0.48 * b.boy;
					if (arm < Ai - 3) score += (Ai - 3 - arm) * 1.2;
					if (arm > Ai + 9) score += (arm - Ai - 9) * 0.5;
				}
			}
			if (part.grup === 'alt') {
				if (o.bel) {
					var wc = 2 * o.bel, wmax = o.belgergin ? 2 * o.belgergin : null;
					var wt = { oturan: 1, normal: 3, bol: 5 }[p.tercih], we2 = wc - b.bel;
					if (wmax) {
						if (b.bel > wmax + 2) why.push({ ad: 'Bel', body: b.bel, lim: wmax, yon: 'dar', lastik: 1 });
						if (b.bel < wc - 14) why.push({ ad: 'Bel', body: b.bel, lim: wc, yon: 'bol', lastik: 1 });
						if (b.bel > wmax) score += (b.bel - wmax) * 4;
						else if (b.bel < wc - 6) score += (wc - 6 - b.bel) * 1.2;
					} else {
						score += Math.abs(we2 - wt);
						if (we2 < -1) score += (-1 - we2) * 4;
						if (we2 < -4) why.push({ ad: 'Bel', body: b.bel, lim: wc, yon: 'dar' });
						if (we2 > 14) why.push({ ad: 'Bel', body: b.bel, lim: wc, yon: 'bol' });
					}
					notes.push({ k: 'bel', ad: 'Bel', body: b.bel, g: wc, gmax: wmax, ease: we2, lastik: !!wmax });
				}
				if (o.basen) {
					var hc = 2 * o.basen, he = hc - b.basen;
					var ht = { oturan: 4, normal: 8, bol: 14 }[p.tercih] - st;
					score += Math.abs(he - ht) * 0.8;
					if (he < 2 - st) score += (2 - st - he) * 3;
					if (he < -2 - st) why.push({ ad: 'Basen', body: b.basen, lim: hc, yon: 'dar' });
					notes.push({ k: 'basen', ad: 'Basen', body: b.basen, g: hc, ease: he });
				}
				if (o.icbacak) {
					var Ii = (female ? 0.45 : 0.45) * b.boy - 4;
					if (part.tip === 'sort') Ii = null;
					if (Ii) {
						if (o.icbacak < Ii - 3) score += (Ii - 3 - o.icbacak) * 1.2;
						if (o.icbacak > Ii + 6) score += (o.icbacak - Ii - 6) * 0.6;
						notes.push({ k: 'icbacak', ad: 'İç bacak', ideal: Ii, g: o.icbacak });
					}
				}
			}
		});
		return { s: s, score: score, notes: notes, ok: !why.length, why: why };
	}
	function recommend(p) {
		/* sayfada seçeneği olmayan beden (ör. kaldırılan 3XL) önerilmez */
		var g = sizeGroup(), list = data.bedenler.filter(function (s) { return !g || !g.querySelector('[data-lu-v]') || sizeBtn(s); });
		var res = list.map(function (s) { return evalSize(p, s); }).filter(function (r) { return r.notes.length; });
		res.sort(function (a, b) { return a.score - b.score; });
		return res;
	}
	function feel(ease, alt) {
		if (alt) return ease < -1 ? 'dar' : ease < 2 ? 'tam' : ease < 6 ? 'rahat' : 'bol';
		return ease < 4 ? 'dar' : ease < 9 ? 'vücuda oturan' : ease < 16 ? 'rahat' : ease < 24 ? 'bol' : 'çok bol';
	}
	function r0(x) { return Math.round(x); }
	/* lastikli bel: gevşek (g) ile gergin (gmax) çevre arasında esner */
	function feelLastik(n) { return n.body > n.gmax ? 'dar' : n.body > n.gmax - 4 ? 'tam oturur' : n.body >= n.g - 6 ? 'rahat' : 'bol'; }
	/* hiçbir beden uymuyorsa: beden önermeden nazik uyarı */
	function noFit(p, r) {
		var w = r.why.slice().sort(function (a, b) { return Math.abs(b.body - b.lim) - Math.abs(a.body - a.lim); })[0];
		var yer = { 'Göğüs': 'göğüste', 'Bel': 'belde', 'Basen': 'basende' }[w.ad] || '', s = esc(r.s.split(' (')[0]);
		var txt = 'Girdiğin bilgilere göre tahmini ' + w.ad.toLowerCase() + ' çevren ~' + r0(w.body) + ' cm. ' + (w.yon === 'dar'
			? 'Bu ürünün sana en yakın bedeni olan ' + s + ' bile ' + yer + ' en fazla ' + r0(w.lim) + ' cm' + (w.lastik ? ' (lastik gerilince)' : '') + '; sana dar gelir.'
			: 'Bu ürünün sana en yakın bedeni olan ' + s + ' bile ' + yer + ' ' + r0(w.lim) + ' cm; sana bol gelir.');
		var a = document.querySelector('.lwl-fab--wa, a[href*="wa.me"], a[href*="api.whatsapp"]'), wa = a && a.href;
		shBody.innerHTML =
			'<div class="lba-r">' +
			'<p class="lba-r__k">Bu üründe sana uygun beden yok</p>' +
			'<p class="lba-r__p">' + p.boy + ' cm · ' + p.kilo + ' kg <button type="button" data-lba-edit>Değiştir</button></p>' +
			'<p class="lba-alt">' + txt + ' Sana uymayacak bir bedeni önermek istemeyiz.</p>' +
			'<p class="lba-alt">Bize WhatsApp’tan yazarsan sana uygun bir ürünü birlikte bulalım. Boyunu ya da kilonu yanlış yazdıysan Değiştir’e dokunabilirsin.</p>' +
			(wa ? '<a class="lba-go" href="' + esc(wa) + '" target="_blank" rel="noopener" style="text-align:center;text-decoration:none">WhatsApp’tan yaz</a>' : '') +
			'<button type="button" class="lba-sec" data-lba-olcu>Ürün ölçülerini gör</button>' +
			'</div>';
	}

	/* ---------- sayfa bağlantıları ---------- */
	function sizeGroup() { return document.querySelector('[data-lu-size]'); }
	function sizeBtn(s, root) {
		var g = root || sizeGroup();
		if (!g) return null;
		var n = String(s).trim().toUpperCase();
		return Array.prototype.find.call(g.querySelectorAll(root ? '[data-q]' : '[data-lu-v]'), function (b) {
			return String(b.getAttribute(root ? 'data-q' : 'data-lu-v')).trim().toUpperCase() === n;
		});
	}
	function isOut(b) { return b && (b.classList.contains('is-out') || b.getAttribute('aria-disabled') === 'true' || b.disabled); }
	function quickSheet() { return document.querySelector('.lu-sh.is-open:not(.luo-x):not(.lba-x)'); }
	var last = null;
	function markRec(s) {
		document.querySelectorAll('.lba-rec').forEach(function (b) { b.classList.remove('lba-rec'); var t = b.querySelector('.lba-rec__t'); if (t) t.remove(); });
		if (!s) { var ob = document.querySelector('.lba-sug'); if (ob) ob.remove(); return; }
		[sizeBtn(s), quickSheet() && sizeBtn(s, quickSheet())].forEach(function (b) {
			if (!b) return;
			b.classList.add('lba-rec');
			var t = document.createElement('em');
			t.className = 'lba-rec__t';
			t.textContent = 'Önerilen';
			b.appendChild(t);
		});
		var g = sizeGroup(), box = g && g.querySelector('.lba-sug');
		if (g && !box) { box = document.createElement('div'); box.className = 'lba-sug'; var sz = g.querySelector('[data-lu-sz]'); if (sz) sz.insertAdjacentElement('afterend', box); }
		var p = ls(PROF_KEY);
		if (box && p) box.innerHTML = '<span>' + p.boy + ' cm · ' + p.kilo + ' kg için önerimiz: <b>' + esc(s.split(' (')[0]) + '</b></span><button type="button" data-lba-open>Değiştir</button>';
	}
	function tName(k) { var t = TERCIH.filter(function (x) { return x.k === k; })[0]; return t ? t.t.toLowerCase() : ''; }
	function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
	window.LWL_BEDEN_PROP = function () {
		var p = ls(PROF_KEY);
		if (!p || !last) return '';
		var g = sizeGroup(), sel = g && g.querySelector('[data-lu-v][aria-checked="true"]');
		return 'Boy ' + p.boy + ' · Kilo ' + p.kilo + ' · ' + (VUCUT.filter(function (x) { return x.k === p.vucut; })[0] || { t: '-' }).t +
			' · Öneri ' + last.best + (last.second ? ' (2. ' + last.second + ')' : '') + (sel ? ' · Seçilen ' + sel.getAttribute('data-lu-v') : '') + ' · ' + V;
	};

	/* ---------- panel ---------- */
	var sh, shBody, open = false, pushed = false, form = { tercih: 'normal', vucut: 'orta' };
	function openPanel() {
		if (!sh) {
			sh = document.createElement('div');
			sh.className = 'lu-sh lu-x luo-x lba-x';
			sh.innerHTML = '<div class="lu-sh__bg" data-close></div><div class="lu-sh__p" role="dialog" aria-modal="true" aria-label="Beden asistanı"><div class="lu-sh__grab"></div>' +
				'<div class="lu-sh__h"><div><b>Bedenimi bul</b><span>Boy ve kilonla sana uygun bedeni bulalım</span></div><button type="button" class="lu-sh__x" data-close aria-label="Kapat">' +
				'<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div><div data-b></div></div>';
			document.body.appendChild(sh);
			shBody = sh.querySelector('[data-b]');
			sh.addEventListener('click', onPanelClick);
			sh.addEventListener('input', function (e) { if (e.target.name) form[e.target.name] = e.target.value; });
			window.addEventListener('popstate', function () { if (open && pushed) closePanel(true); });
			document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
		}
		var p = ls(PROF_KEY);
		if (p) form = { boy: p.boy, kilo: p.kilo, vucut: p.vucut === 'genis' || p.vucut === 'gobek' ? p.vucut : 'orta' };
		renderForm();
		sh.classList.add('is-open');
		document.body.classList.add('lu-noscroll');
		open = true;
		pushed = !quickSheet() && !document.querySelector('.luo-x.is-open:not(.lba-x)');
		if (pushed) { try { history.pushState({ lbaSh: 1 }, ''); } catch (e) {} }
	}
	function closePanel(fromPop) {
		if (!open) return;
		sh.classList.remove('is-open');
		if (!quickSheet() && !document.querySelector('.luo-x.is-open:not(.lba-x)')) document.body.classList.remove('lu-noscroll');
		open = false;
		if (fromPop !== true && pushed) { try { if (history.state && history.state.lbaSh) history.back(); } catch (e) {} }
		pushed = false;
	}
	function chips(name, list, cur) {
		return '<div class="lba-ch" role="radiogroup">' + list.map(function (x) {
			return '<button type="button" role="radio" aria-checked="' + (x.k === cur) + '" class="' + (x.k === cur ? 'is-on' : '') + '" data-ch="' + name + '" data-v="' + x.k + '">' +
				'<b>' + x.t + '</b>' + (x.d ? '<small>' + x.d + '</small>' : '') + '</button>';
		}).join('') + '</div>';
	}
	function renderForm(err) {
		shBody.innerHTML =
			'<div class="lba-f">' +
			'<div class="lba-row"><label>Boy<span><input name="boy" type="number" inputmode="numeric" min="140" max="215" placeholder="178" value="' + (form.boy || '') + '"><i>cm</i></span></label>' +
			'<label>Kilo<span><input name="kilo" type="number" inputmode="numeric" min="40" max="200" placeholder="78" value="' + (form.kilo || '') + '"><i>kg</i></span></label></div>' +
			'<p class="lba-q">Vücut yapın</p>' + chips('vucut', VUCUT, form.vucut) +
			(err ? '<p class="lba-err">' + err + '</p>' : '') +
			'<button type="button" class="lba-go" data-lba-go>Bedenimi bul</button>' +
			'<p class="lba-priv">Bilgilerin yalnızca beden önerisi ve önerilerimizi iyileştirmek için kullanılır; cihazında saklanır, siparişinde beden notu olarak yer alır. <a href="/policies/privacy-policy" target="_blank" rel="noopener">Gizlilik politikası</a></p>' +
			'</div>';
	}
	function onPanelClick(e) {
		if (e.target.closest('[data-close]')) { closePanel(); return; }
		var c = e.target.closest('[data-ch]');
		if (c) {
			form[c.getAttribute('data-ch')] = c.getAttribute('data-v');
			c.parentNode.querySelectorAll('[data-ch]').forEach(function (b) { var on = b === c; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on); });
			return;
		}
		if (e.target.closest('[data-lba-go]')) { run(); return; }
		if (e.target.closest('[data-lba-edit]')) { renderForm(); return; }
		var pick = e.target.closest('[data-lba-pick]');
		if (pick) {
			var s = pick.getAttribute('data-lba-pick'), qs = quickSheet(), qb = qs && sizeBtn(s, qs);
			closePanel();
			if (qb) { setTimeout(function () { qb.click(); }, 120); return; }
			var b = sizeBtn(s);
			if (b) { b.click(); setTimeout(function () { b.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 150); }
			return;
		}
		if (e.target.closest('[data-lba-olcu]')) {
			closePanel();
			var o = document.querySelector('[data-luo-open]');
			if (o) setTimeout(function () { o.click(); }, 380);
		}
	}
	function run() {
		var boy = parseInt(form.boy, 10), kilo = parseInt(form.kilo, 10);
		if (!(boy >= 140 && boy <= 215) || !(kilo >= 40 && kilo <= 200)) { renderForm('Boyunu (140–215 cm) ve kilonu (40–200 kg) yaz.'); return; }
		var p = { boy: boy, kilo: kilo, vucut: form.vucut || 'orta', t: Date.now() };
		ls(PROF_KEY, p);
		var res = recommend(p);
		if (!res.length) { renderForm('Bu ürün için öneri hesaplanamadı. Ölçü tablosuna göz atabilirsin.'); return; }
		var fits = res.filter(function (r) { return r.ok; });
		if (!fits.length) { last = null; markRec(null); noFit(p, res[0]); return; }
		var best = fits[0], second = fits[1] && fits[1].score - best.score < 3 ? fits[1] : null;
		last = { best: best.s, second: second ? second.s : '' };
		markRec(best.s);
		try { window.dispatchEvent(new CustomEvent('lwl:beden-oneri', { detail: { profil: p, oneri: best.s, ikinci: last.second, v: V } })); } catch (e) {}
		var qs = quickSheet(), bb = sizeBtn(best.s), out = isOut(bb);
		var lines = best.notes.map(function (n) {
			if (n.lastik) return '<li><b>Bel:</b> senin tahmini bel çevren ~' + r0(n.body) + ' cm, ' + esc(best.s.split(' (')[0]) + ' bedende lastikli bel ' + r0(n.g) + '–' + r0(n.gmax) + ' cm arası esner → <em>' + feelLastik(n) + '</em></li>';
			if (n.ease != null) return '<li><b>' + n.ad + ':</b> senin tahmini ' + n.ad.toLowerCase() + ' çevren ~' + r0(n.body) + ' cm, ' + esc(best.s) + ' bedende ' + r0(n.g) + ' cm → <em>' + feel(n.ease, n.k !== 'gogus') + '</em>' + (n.lastik ? ' (lastikli bel)' : '') + '</li>';
			if (n.k === 'boy') return '<li><b>Boy:</b> ' + String(n.g).replace('.', ',') + ' cm ' + (n.g < n.ideal - 3 ? '(kısa kesim)' : n.g > n.ideal + 6 ? '(uzun kesim)' : '(boyuna uygun)') + '</li>';
			if (n.k === 'icbacak') return '<li><b>İç bacak:</b> ' + String(n.g).replace('.', ',') + ' cm ' + (n.g > n.ideal + 4 ? '(paçada katlanma olabilir)' : n.g < n.ideal - 2 ? '(bileğin üstünde kalabilir)' : '(boyuna uygun)') + '</li>';
			return '';
		}).join('');
		var alt = '';
		var note = meta.not ? '<p class="lba-kn">Bu ürünün kalıbı' + (meta.kalip ? ' (' + esc(meta.kalip) + ')' : '') + ' ve gerçek ölçüleri hesaba katıldı; ayrıca beden küçültüp büyütmene gerek yok.</p>' : '';
		var cta = out ? '<button type="button" class="lba-go" data-lba-pick="' + esc(best.s) + '">' + esc(best.s) + ' tükendi · Gelince haber ver</button>'
			: '<button type="button" class="lba-go" data-lba-pick="' + esc(best.s) + '">' + (qs ? esc(best.s) + ' ile sepete ekle' : esc(best.s) + ' bedeni seç') + '</button>';
		shBody.innerHTML =
			'<div class="lba-r">' +
			'<p class="lba-r__k">Sana önerimiz</p><p class="lba-r__s">' + esc(best.s.split(' (')[0]) + '</p>' +
			'<p class="lba-r__p">' + p.boy + ' cm · ' + p.kilo + ' kg <button type="button" data-lba-edit>Değiştir</button></p>' +
			alt + note + '<ul class="lba-why">' + lines + '</ul>' + cta +
			'<button type="button" class="lba-sec" data-lba-olcu>Ürün ölçülerini gör</button>' +
			'<p class="lba-priv">Öneri, ürünün gerçek ölçüleri ve verdiğin bilgilerle hesaplanan bir tahmindir.</p>' +
			'</div>';
	}

	/* ---------- açılış, tanıtım ---------- */
	document.addEventListener('click', function (e) {
		if (e.target.closest('[data-lba-open], [data-luo-bul]')) { e.preventDefault(); hideTip(); openPanel(); }
	});
	var tip;
	function hideTip() { if (tip) { tip.remove(); tip = null; } }
	function maybeTour() {
		if (ls(PROF_KEY) || ls(TOUR_KEY)) return;
		var q = location.search + ' ' + document.referrer;
		if (!/utm_source=(meta|facebook|instagram|fb|ig)|fbclid|instagram\.com|facebook\.com/i.test(q)) return;
		var btn = document.querySelector('[data-luo-bul]');
		if (!btn || !window.IntersectionObserver) return;
		var io = new IntersectionObserver(function (en) {
			if (!en[0].isIntersecting) return;
			io.disconnect();
			setTimeout(function () {
				if (open || ls(TOUR_KEY)) return;
				ls(TOUR_KEY, 1);
				tip = document.createElement('div');
				tip.className = 'lba-tip';
				tip.innerHTML = '<b>Bedenini bilmiyor musun?</b><span>Boy ve kilonla 10 saniyede bulalım.</span><button type="button" aria-label="Kapat">×</button>';
				tip.addEventListener('click', function (ev) { hideTip(); if (!ev.target.closest('button')) openPanel(); });
				btn.parentNode.style.position = 'relative';
				btn.parentNode.appendChild(tip);
				setTimeout(hideTip, 9000);
			}, 1200);
		}, { threshold: 0.6 });
		io.observe(btn);
	}

	/* "Bedenimi bul" düğmesi: beden başlığında "Ürün ölçüleri"nin yanına */
	(function () {
		var o = document.querySelector('.lu__lbl [data-luo-open]');
		if (!o || document.querySelector('.lu__lbl [data-luo-bul]')) return;
		var w = document.createElement('span');
		w.className = 'luo__lbl-r';
		o.parentNode.insertBefore(w, o);
		var b = document.createElement('button');
		b.type = 'button';
		b.className = 'lu__guide lba-btn';
		b.setAttribute('data-luo-bul', '');
		b.textContent = 'Bedenimi bul';
		w.appendChild(b);
		w.appendChild(o);
	})();
	/* beden düğmelerine tahmini kilo aralığı (asistanı kullanmayanlar için; 178 cm, standart vücut, asistanla aynı hesap) */
	(function () {
		var g = sizeGroup(), box = g && g.querySelector('[data-lu-sz]');
		if (!box || !data.parcalar.some(function (p) { return p.grup === 'ust'; }) || box.querySelector('[data-lu-v] small')) return;
		var R = {};
		for (var k = 45; k <= 140; k++) {
			var r = recommend({ boy: 178, kilo: k, vucut: 'orta' }).filter(function (x) { return x.ok; })[0];
			if (!r) continue;
			var gn = r.notes.filter(function (n) { return n.k === 'gogus'; })[0];
			if (gn && gn.ease > 20) continue;
			R[r.s] = R[r.s] ? [R[r.s][0], k] : [k, k];
		}
		var n = 0;
		box.querySelectorAll('[data-lu-v]').forEach(function (b) {
			var x = R[b.getAttribute('data-lu-v')];
			if (!x) return;
			var sm = document.createElement('small');
			sm.textContent = '(' + x[0] + '-' + x[1] + ' KG)';
			var t = b.querySelector('.lba-rec__t');
			b.insertBefore(sm, t || null);
			n++;
		});
		if (!n) return;
		box.classList.add('is-long');
		var p = document.createElement('p');
		p.className = 'lba-kgnot';
		p.style.cssText = 'margin:8px 0 0;font-size:12px;line-height:1.4;color:#75604f';
		p.innerHTML = 'Kilolar 178 cm boy ve standart vücut için tahminidir. Boyun farklıysa <a href="#" data-lba-open style="color:inherit;text-decoration:underline">Bedenimi bul</a>.';
		box.insertAdjacentElement('afterend', p);
	})();
	/* hızlı beden panelinde de "Bedenimi bul" */
	function quickLink() {
		var q = quickSheet();
		if (!q || q.querySelector('[data-luo-bul]')) return;
		var h = q.querySelector('.lu-sh__h');
		if (!h) return;
		var d = document.createElement('div');
		d.className = 'lba-qrow';
		d.innerHTML = '<button type="button" class="lu__guide lba-btn" data-luo-bul>Bedenimi bul</button>';
		h.insertAdjacentElement('afterend', d);
	}
	/* sepete eklerken bu ürünün satırına beden notu (_beden_oneri) */
	var vids = {};
	try { (window.ShopifyAnalytics.meta.product.variants || []).forEach(function (v) { vids[String(v.id)] = 1; }); } catch (e) {}
	if (window.fetch && !window.__lbaFetch) {
		window.__lbaFetch = true;
		var of = window.fetch;
		window.fetch = function (u, o) {
			try {
				if (String(u).indexOf('cart/add') >= 0 && o && typeof o.body === 'string') {
					var prop = window.LWL_BEDEN_PROP();
					if (prop) {
						var b = JSON.parse(o.body), items = b.items || [b];
						items.forEach(function (it) {
							if (vids[String(it.id)]) { it.properties = it.properties || {}; it.properties._beden_oneri = prop; }
						});
						o = Object.assign({}, o, { body: JSON.stringify(b) });
					}
				}
			} catch (e) {}
			return of.call(this, u, o);
		};
	}

	/* kayıtlı profil varsa öneriyi hemen göster */
	var prof = ls(PROF_KEY);
	if (prof) {
		var r = recommend(prof).filter(function (x) { return x.ok; });
		if (r.length) { last = { best: r[0].s, second: r[1] && r[1].score - r[0].score < 3 ? r[1].s : '' }; markRec(r[0].s); }
	}
	/* hızlı beden paneli açılınca önerilen bedeni orada da işaretle */
	document.addEventListener('click', function () {
		setTimeout(function () { var q = quickSheet(); if (!q) return; quickLink(); if (last && !q.querySelector('.lba-rec')) markRec(last.best); }, 80);
	});
	maybeTour();
})();
